import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Share} from '../domain';
import {Page} from '../../components/common-interfaces';
import {environment} from '../../../environments/environment';
import {MultishareHistoryFilter} from './multishare-history-table/multishare-history-table.component';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MultishareHistoryClientService {

  constructor(private http: HttpClient) {
  }

  fetchEntries(filter: MultishareHistoryFilter): Observable<Page<Share>> {
    return this.http.post<Page<Share>>(
      `${environment.apiSegments}/multishare/history`,
      filter,
    );
  }
}
